import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Header.css";
import imagenes from "../../assets/Imagenes";

const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [submenuOpen, setSubmenuOpen] = useState(false);
	const navigate = useNavigate(); // Hook para la navegación

	const toggleMenu = () => setMenuOpen(!menuOpen);
	const toggleSubmenu = () => setSubmenuOpen(!submenuOpen);

	// Función para redirigir a Home y luego hacer scroll a una sección
	const handleNavClick = (sectionId) => {
		setMenuOpen(false); // Cierra el menú móvil si está abierto
		navigate("/"); // Redirige a la página principal
		setTimeout(() => {
			document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
		}, 300); // Espera 300ms para asegurarse de que la página cargó
	};

	return (
		<header>
			<div className="header-container">
				{/* LOGO */}
				<NavLink to="/" className="logo">
					<img src={imagenes.logo} alt="Inmobiliaria Percara Logo" loading="lazy" />
					<spam className="spam-percara-negocios">
						Percara Negocios Inmobiliarios
					</spam>
				</NavLink>

				{/* MENÚ DESKTOP */}
				<nav className="nav-desktop">
					<div className="dropdown">
						<button className="dropdown-btn" onClick={toggleSubmenu}>
							Inmuebles ▼
						</button>
						{submenuOpen && (
							<div className="dropdown-content">
								<NavLink to="/campos">Campos</NavLink>
								<NavLink to="/casas">Casas</NavLink>
								<NavLink to="/departamentos">Departamentos</NavLink>
								<NavLink to="/forestaciones">Forestaciones</NavLink>
								<NavLink to="/galpones">Galpones</NavLink>
								<NavLink to="/locales">Locales y oficinas</NavLink>
								<NavLink to="/quintas">Quintas</NavLink>
								<NavLink to="/terrenos">Terrenos</NavLink>
								<NavLink to="/otraspropiedades">Otras propiedades</NavLink>

							</div>
						)}
					</div>
					<button className="nav-link" onClick={() => handleNavClick("About")}>Sobre Nosotros</button>
					<button className="nav-link" onClick={() => handleNavClick("Contact")}>Contactos</button>
				</nav>

				{/* BOTÓN MENÚ MOBILE */}
				<button onClick={toggleMenu} className="menu-button">
					{menuOpen ? <FaTimes /> : <FaBars />}
				</button>
			</div>

			{/* MENÚ MOBILE */}
			{menuOpen && (
				<motion.div
					initial={{ opacity: 0, y: -10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -10 }}
					className="nav-mobile"
				>
					<button className="dropdown-btn" onClick={toggleSubmenu}>
						Inmuebles ▼
					</button>
					{submenuOpen && (
						<div className="dropdown-content">
							<NavLink to="/campos" onClick={toggleMenu}>Campos</NavLink>
							<NavLink to="/casas" onClick={toggleMenu}>Casas</NavLink>
							<NavLink to="/departamentos" onClick={toggleMenu}>Departamentos</NavLink>
							<NavLink to="/forestaciones" onClick={toggleMenu}>Forestaciones</NavLink>
							<NavLink to="/galpones" onClick={toggleMenu}>Galpones</NavLink>
							<NavLink to="/locales" onClick={toggleMenu}>Locales y oficinas</NavLink>
							<NavLink to="/quintas" onClick={toggleMenu}>Quintas</NavLink>
							<NavLink to="/terrenos" onClick={toggleMenu}>Terrenos</NavLink>
							<NavLink to="/otraspropiedades">Otras propiedades</NavLink>


						</div>
					)}
					<button className="nav-link" onClick={() => handleNavClick("About")}>Sobre Nosotros</button>
					<button className="nav-link" onClick={() => handleNavClick("Contact")}>Contactos</button>
				</motion.div>
			)}
		</header>
	);
};

export default Header;
